import * as React from 'react';
import ModalForm from './ModalForm';
import { notify } from '../../Utils';
import { isUndefined } from 'lodash';

const initialState = {
  isLoading: false,
  rate: null,
  industryExperience: null,
  insufficientAnalogs: null,
  insufficientMarketDesc: null,
  marketingTeamMember: null,
  techTeamMember: null,
};

class RecommendationInfo extends React.Component<any, any> {
  state = initialState;

  getErrorMessage({ e, status }: { e: any; status?: number }) {
    return `Произошла ошибка ${status || ''}${
      typeof e === 'string' ? `:\n${e}` : '.\n'
    }\nПросьба сообщить об ошибке на sitehelp@sk.ru`;
  }

  handlerClick = () => {
    this.setState({
      ...initialState,
      isLoading: true,
    });

    this.props.onPlageSearch({
      success: (data) => {
        this.setState({
          ...this.state,
          isLoading: false,
          rate: data.originality_rating,
        });
      },
      error: (data) => {
        const message = this.getErrorMessage({
          e: data.responseJSON?.detail,
          status: data.status,
        });

        notify(message);
        this.setState((prevState) => ({ ...prevState, ...initialState }));
      },
    });

    this.props.getRecommendations({
      success: (data) => {
        const result = JSON.parse(data);

        this.setState({
          ...this.state,
          industryExperience: result.IndustryExperience,
          insufficientAnalogs: result.InsufficientAnalogs,
          insufficientMarketDesc: result.InsufficientMarketDesc,
          marketingTeamMember: result.MarketingTeamMember,
          techTeamMember: result.TechTeamMember,
        });
      },
      error: (response, textStatus) => {
        let message = '';

        const error = JSON.parse(textStatus);

        switch (true) {
          case typeof error === 'string':
            message = error;
            break;
          case typeof error?.detail?.field_errors === 'object':
            const errors = error.detail.field_errors;

            Object.entries(errors).forEach(([key, value]) => {
              const valueToStr =
                typeof value === 'object'
                  ? (value as string[]).reduce((acc, cur) => {
                      return `${acc}${cur}. `;
                    }, '')
                  : '';

              message = `${message}${key}: ${valueToStr}\n`;
            });
            break;
          default:
            break;
        }

        notify(this.getErrorMessage({ e: message, status: response }));

        this.setState((prevState) => ({ ...prevState, ...initialState }));
      },
    });
  };

  handlerCloseModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      ...initialState,
    }));
    this.props.onHide();
  };

  render() {
    const { rate } = this.state;
    let rateStyle = {
      fontWeight: 'bold',
      color: 'black',
    };

    const dangerPercentAmount = 10;
    const warningPercentAmount = 29;

    if (rate < dangerPercentAmount) {
      rateStyle = {
        ...rateStyle,
        color: 'red',
      };
    }
    if (rate <= warningPercentAmount && rate >= dangerPercentAmount) {
      rateStyle = {
        ...rateStyle,
        color: 'yellow',
      };
    }

    return (
      <div>
        {/* @ts-ignore */}
        <ModalForm
          isOpen={this.props.isOpen}
          onRequestClose={this.handlerCloseModal}
          modalHeader={
            <div>Оценить оригинальность и получить рекомендации</div>
          }
          modalFooter={
            <>
              <button
                className="btn btn-primary"
                onClick={this.handlerClick}
                disabled={this.state.isLoading}
              >
                Проверить
              </button>
              <button
                className="btn btn-default"
                onClick={this.handlerCloseModal}
              >
                Отмена
              </button>
            </>
          }
        >
          {!this.state.rate ? (
            <p>
              Нажимая кнопку «Проверить», Вы можете запросить оценку
              оригинальности Вашей заявки, которая проводится на основе
              текстового анализа со всеми заявками, рассмотренными Фондом
              «Сколково» ранее. Результатом анализа является оценка в % степени
              уникальности в сравнении с проектами на аналогичную тему, если
              такие будут найдены в базе заявок, полученных Фондом «Сколково».
              Данная оценка носит информационный характер и не отражает
              вероятность получения положительного либо отрицательного
              результата экспертизы.
            </p>
          ) : (
            <div>
              <h5>Уровень оригинальности</h5>
              <p>
                Оригинальность <span style={rateStyle}>{rate}%</span>
              </p>
              <h5>Рекомендации</h5>
              <h6>Описание конкурентных преимуществ перед аналогами</h6>
              <p>{this.state.insufficientAnalogs}</p>
              <h6>Наличие технического специалиста</h6>
              <p>{this.state.techTeamMember}</p>
              <h6>Наличие специалиста по продвижению</h6>
              <p>{this.state.marketingTeamMember}</p>
              <h6>Описание рынка</h6>
              <p>{this.state.insufficientMarketDesc}</p>
              <h6>Опыт в целевом сегменте</h6>
              <p>{this.state.industryExperience}</p>
            </div>
          )}
        </ModalForm>
      </div>
    );
  }
}

export default RecommendationInfo;
